import { faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DCMCreateExamModal from 'components/Modals/AddExamModal';
import React, { useEffect, useState } from 'react'
import { Button, Card, Container } from 'react-bootstrap';
import { toast } from 'react-toastify'
import { ExamServices } from '../../../Services/examServices';
import { UserServices } from '../../../Services/userServices';
import Examcard from '../Dashboard/Home/Examcard';
import CreateExam from './CreateExam/CreateExam.index';
import { useLoader } from 'components/Loader/Loader';




export default function Exam() {

    const token = localStorage.getItem("authKey");

    const [examData, setExamData] = useState<any[]>([]);

    const [showCreateExam, setShowCreateExam] = useState<boolean>(false);
    const {setLoading} = useLoader();

    const getExamData = async () => {
        setLoading(true);
        await ExamServices.getAllExams().then((res) => {
            if (res.status === 200) {
                setExamData(res.data.data.examData);
            }
        }).catch((err) => {
            toast.error(err);
        })
        .finally(() => {
            setLoading(false);
        })

    }

    useEffect(() => {
        getExamData();
    }, [showCreateExam])

    return (
        <>
            <DCMCreateExamModal
                show={showCreateExam}
                setShow={setShowCreateExam}
                reload={getExamData}
            />
            <Container fluid className="py-4">
                <div className="d-flex flex-wrap justify-content-between align-items-center gap-2 mb-4">
                    <div>
                        <h5 className="mb-1 fw-bold">Exams</h5>
                        <span className="text-muted fs-12">
                            Manage exams · {examData?.length || 0} total
                        </span>
                    </div>
                    <Button variant="primary" onClick={() => setShowCreateExam(true)}>
                        Create Exam <FontAwesomeIcon icon={faPlusCircle} className="ms-1" />
                    </Button>
                </div>

                {examData?.length > 0 ? (
                    examData.map((data: any) => (
                        <Examcard
                            key={data._id}
                            examData={data}
                            reloadData={getExamData}
                        />
                    ))
                ) : (
                    <Card className="xrg-card shadow-sm">
                        <Card.Body className="text-center py-5 text-muted">
                            No exams found
                        </Card.Body>
                    </Card>
                )}
            </Container>
        </>
    )
}